import api from '../api'

export default {
  authenticate: async function (context, data) {
    try {
      const user = await api.user.login(data.user, data.password)
      const groups = await api.user.getGroups(data.user)
      context.commit('authenticated', { user, username: data.user })
      context.commit('setUserGroups', groups)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
  signup: async function (context, data) {
    try {
      await api.user.signup(data)
      context.commit('setNewUser', data.user)
    } catch (e) {
      throw new Error(e)
    }
  },
  verify: async function (context, data) {
    try {
      await api.user.verify(data.code, data.user)
    } catch (e) {
      throw new Error(e)
    }
  },
  signout: function (context) {
    api.user.signout(context.state.user)
    context.commit('signout')
  },
  checkLogin: async function (context) {
    const validSession = await api.user.checkLogin()
    if (!validSession) {
      context.commit('signout')
    }
    return validSession
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js